<script setup lang="ts">
import { RouterLink, RouterView } from 'vue-router'
import { useChatStore } from '@/stores/chat'
import { useNotifyStore } from '@/stores/notify'
import { onMounted } from 'vue'
import OrderNotifyOverlay from '@/components/OrderNotifyOverlay.vue'

const chatStore = useChatStore()
const notifyStore = useNotifyStore()

function handleCloseNotification(msgId: number) {
  notifyStore.removeOrderNotification(msgId)
}

async function handleIgnoreNotification(msgId: number) {
  try {
    await notifyStore.acknowledgeNotification([msgId])
  } catch (error) {
    console.error('标记通知已读失败:', error)
  }
}

onMounted(() => {
  chatStore.connectWebSocket()
  notifyStore.syncNotifications()
})
</script>

<template>
  <RouterView />
  <OrderNotifyOverlay
    v-for="(notification, index) in notifyStore.orderNotifyQueue"
    :key="notification.msg_id"
    :data="notification"
    :top-offset="80 + index * 60"
  />
</template>

<style scoped></style>
